const SearchInput = ({ value, setValue, onPressEnter }) => {
    const handlerClick = () => {
        if (value !== "") {
            onPressEnter()
        }
    }
    return (
        <div className="flex mb-4">
            <div className="grow group relative">
                <svg width="20" height="20" fill="currentColor" className="absolute left-3 top-1/2 -mt-2.5 text-slate-400 pointer-events-none group-focus-within:text-blue-500" aria-hidden="true">
                    <path fillRule="evenodd" clipRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" />
                </svg>
                <input
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            handlerClick()
                        }
                    }}
                    className="focus:ring-2 focus:ring-blue-500 focus:outline-none appearance-none w-full text-sm leading-6 text-slate-900 placeholder-slate-400 rounded-l-md py-2 pl-10 ring-1 ring-slate-200 shadow-sm" type="text" aria-label="Filter projects" placeholder="Filter projects..." />
            </div>
            <button onClick={handlerClick} className="flex-none w-14 py-2 px-3  bg-indigo-500 text-white text-sm font-semibold rounded-r-md shadow focus:outline-none ring-1 ring-slate-200" type="sumbit">Go</button>
        </div>)
}

export default SearchInput
